import { render, staticRenderFns } from "./MemoryYjj.vue?vue&type=template&id=22b5eae5&scoped=true&"
import script from "./MemoryYjj.vue?vue&type=script&lang=js&"
export * from "./MemoryYjj.vue?vue&type=script&lang=js&"
import style0 from "./MemoryYjj.vue?vue&type=style&index=0&id=22b5eae5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5eae5",
  null
  
)

export default component.exports